import ApiClient from "@/api/ApiClient";
import { PaymentMethodCardListResponse } from "@API/src/component/memoruHome/paymentMethod/types";
import { MessageOkResponse } from "chaild-entity/src/component/memoruHome/cart/types";
import {
  PostPaymentRequest,
  DeletePaymentRequest,
} from "@/model/request/payment";
import {
  isTypePaymentMethodCardListResponse,
  isTypeMessageOkResponse,
} from "@/model/typeGuard/payment";

export default class ApiPayment {
  public static async fetchPaymentList(): Promise<PaymentMethodCardListResponse> {
    const response = await ApiClient.get(`/payment-method/card`, null);
    if (isTypePaymentMethodCardListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async postPayment(
    request: PostPaymentRequest
  ): Promise<MessageOkResponse> {
    const response = await ApiClient.post(`/payment-method/card`, request);
    if (isTypeMessageOkResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async deletePayment(
    request: DeletePaymentRequest
  ): Promise<MessageOkResponse> {
    const response = await ApiClient.delete(
      `/payment-method/card/${request.cardSeq}`,
      request
    );
    if (isTypeMessageOkResponse(response)) {
      return response;
    }
    throw response;
  }
}
